// @generated by protobuf-ts 2.11.1 with parameter optimize_code_size,long_type_number
// @generated from protobuf file "bianka/enums/gig/engine.proto" (package "bianka.enums.gig", syntax proto3)
// tslint:disable
/**
 * @generated from protobuf enum bianka.enums.gig.Engine
 */
export enum Engine {
    /**
     * @generated from protobuf enum value: ENGINE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: ENGINE_DEFAULT = 1;
     */
    DEFAULT = 1,
    /**
     * @generated from protobuf enum value: ENGINE_LIMITED_EDITION = 2;
     */
    LIMITED_EDITION = 2,
    /**
     * @generated from protobuf enum value: ENGINE_PRO = 3;
     */
    PRO = 3,
    /**
     * @generated from protobuf enum value: ENGINE_STOREFRONT = 4;
     */
    STOREFRONT = 4,
    /**
     * @generated from protobuf enum value: ENGINE_LIQUID_ENGINE = 5;
     */
    LIQUID_ENGINE = 5,
    /**
     * @generated from protobuf enum value: ENGINE_FEATURED = 6;
     */
    FEATURED = 6,
    /**
     * @generated from protobuf enum value: ENGINE_PROMOTED = 7;
     */
    PROMOTED = 7,
    /**
     * @generated from protobuf enum value: ENGINE_FIVERR_LEARN = 8;
     */
    FIVERR_LEARN = 8,
    /**
     * @generated from protobuf enum value: ENGINE_FIXED_PRICING = 9;
     */
    FIXED_PRICING = 9,
    /**
     * @generated from protobuf enum value: ENGINE_LETOR = 10;
     */
    LETOR = 10,
    /**
     * @generated from protobuf enum value: ENGINE_STUDIO = 11;
     */
    STUDIO = 11,
    /**
     * @generated from protobuf enum value: ENGINE_FIVERR_CHOICE = 12;
     */
    FIVERR_CHOICE = 12,
    /**
     * @generated from protobuf enum value: ENGINE_LETOR_FIXED_PRICING = 13;
     */
    LETOR_FIXED_PRICING = 13,
    /**
     * @generated from protobuf enum value: ENGINE_PROMOTED_GIGS = 14;
     */
    PROMOTED_GIGS = 14,
    /**
     * @generated from protobuf enum value: ENGINE_CHOICE_MODALITY = 15;
     */
    CHOICE_MODALITY = 15,
    /**
     * @generated from protobuf enum value: ENGINE_RECOMMENDATION_FTB_FRIENDLY = 16;
     */
    RECOMMENDATION_FTB_FRIENDLY = 16,
    /**
     * @generated from protobuf enum value: ENGINE_RECOMMENDATION_EXPRESS_DELIVERY = 17;
     */
    RECOMMENDATION_EXPRESS_DELIVERY = 17,
    /**
     * @generated from protobuf enum value: ENGINE_RECOMMENDATION_RETURNING_BUYERS = 18;
     */
    RECOMMENDATION_RETURNING_BUYERS = 18,
    /**
     * @generated from protobuf enum value: ENGINE_LOCALIZATION_SELLERS = 19;
     */
    LOCALIZATION_SELLERS = 19,
    /**
     * @generated from protobuf enum value: ENGINE_RELAXED = 20;
     */
    RELAXED = 20,
    /**
     * @generated from protobuf enum value: ENGINE_AGENCY = 21;
     */
    AGENCY = 21,
    /**
     * @generated from protobuf enum value: ENGINE_VIDEO_STRIP_GIG_TYPE = 22;
     */
    VIDEO_STRIP_GIG_TYPE = 22
}
